module.exports = __webpack_public_path__ + "img/serviceImg2.810449f8.gif";